import { GABrandList } from "@type/index";
import { getRegionFromUrl } from "@util/common";
import { isEUCountry } from "@util/country";

export const isClient = typeof window !== "undefined";

export const TRACK_EVENT = "trackEvent";
export const TRACK_EVENT_SEARCH = "trackEventSearch";

export type GATrackEventType = {
  _clear?: boolean;
  brand?: GABrandList;
  event?: string;
  value?: number;
  eventAction: string;
  eventCategory: string;
  eventLabel: string;
  eventValue?: string;
  itemIndex?: string;
  itemId?: string;
  searchTerm?: any;
  resultsNumber?: string;
  genderFilter?: string;
  categoryFilter?: any;
  sizeFilter?: any;
  heightFilter?: any;
};

export type GATrackPageView = {
  brand: string;
  event: string;
  pageType: string;
  subID: string;
  pageUrlPath: string;
  pageTitle: string;
  previousPageExists: boolean;
};

/**
 * Track an event such as clicking event on GoogleAnalytics
 * via sending data to dataLayer of window object.
 *
 * @param data - Analytics data
 */
export const sendTrackEvent = (data: GATrackEventType): void => {
  if (!isClient) {
    return;
  }
  if (!window.dataLayer) {
    return;
  }
  if (isEUCountry(getRegionFromUrl())) {
    return;
  }

  const eventData = {
    ...data,
    event: data.event || "trackEvent"
  };

  if (
    window.UQCustomerAppAndroid &&
    window.UQCustomerAppAndroid.receiveAnalyticsData
  ) {
    // Android App
    window.UQCustomerAppAndroid.receiveAnalyticsData(JSON.stringify(eventData));
  } else if (
    window.webkit &&
    window.webkit.messageHandlers.receiveAnalyticsData
  ) {
    // iOS App
    window.webkit.messageHandlers.receiveAnalyticsData.postMessage(eventData);
  }
  // Web Browser and Native App
  window.dataLayer.push(data);
};

export const sendTrackPageView = (data: GATrackPageView): void => {
  if (!isClient) {
    return;
  }
  if (!window.dataLayer) {
    return;
  }
  if (isEUCountry(getRegionFromUrl())) {
    return;
  }
  window.dataLayer.push(data);
};
